import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore, useEstimateStructure, useVisibilityModeCellClassName, ValueCell
} from "@tools";

export const TimeCell = observer(({
  extendPadding,
  ...cellProps
}) => {
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { allowEdition } = useEstimateEditorSettings();
  const { hideSummaryTime } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryTime);
  
  return <ValueCell
    size="large"
    className={className}
    extendPadding={extendPadding || allowEdition || visibilityMode}
    { ...cellProps}
  />;
})